import React from 'react';
import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import {observer} from "mobx-react";
import {BettingZoneDrawerMenuItem} from "./betting-zone.drawer-menu.item";

export const BettingZoneDrawerMenuAccordionItems = observer(({controller, setIsMenuVisible, expandedItemId, setExpandedItemId, navigate, item}) => {
  return item.hasItems ? (<div className={classNames(styles.accordion_wrapper, {[styles.open]: expandedItemId === item.id})}>
    <ul className={styles.accordion_inner}>
      {item.items.map((child, index) => (
        <BettingZoneDrawerMenuItem
          key={child.id}
          item={child}
          navigate={navigate}
          controller={controller}
          position={index + 1}
          setIsMenuVisible={setIsMenuVisible}
          setExpandedItemId={setExpandedItemId}
        />
      ))}
    </ul>
  </div>) : null
});